import axios from 'axios';
import swal from "sweetalert";
import {
    loginConfirmedAction,
    logout,
} from '../store/actions/AuthActions';
import Baseurl from '../Baseurl'
import { tokenget } from '../jsx/components/OtpVerification/OtpVerification';
import { useHistory } from "react-router-dom";
var tokens=''
export function signUp(email, password) {
    //axios call

    const postData = {
        email,
        password,
        returnSecureToken: true,
    };

    return axios.post(
        `https://identitytoolkit.googleapis.com/v1/accounts:signUp?key=AIzaSyD3RPAp3nuETDn9OQimqn_YF6zdzqWITII`,
        postData,
    );
}

export default function tokenfetch(token){      
tokens=token
tokenget(token)
}
export function login(email, password) {
    const postData = {
        "Email": `${email}`,
        "Password": `${password}`,
        // "Token":`${tokens}`,
        // "Online":true
    };

    return axios.post(
        `${Baseurl.baseurl}/staff/staff-login`,
        postData,
    );
}

export function formatError(errorResponse) {
    switch (errorResponse) {
        case 'EMAIL_EXISTS':
           // return 'Email already exists';
            swal("Oops", "Email already exists", "error");
            break;
        case 'EMAIL_NOT_FOUND':
           //return 'Email not found';
           swal("Oops", "Email not found", "error",{ button: "Try Again!",});
           break;
           // swal('Oops',  "There is no user record corresponding to this identifier. The user may have been deleted.");
        case 'INVALID_PASSWORD':
            //return 'Invalid Password';
            swal("Oops", "Invalid Password", "error",{ button: "Try Again!",});
           break;
        case 'Staff Not Found':
            // return 'Email already exists';
            swal("Oops", "Staff Not Found", "error");
            break;
        case 'Wrong Email Or Password':
                // return 'Email already exists';
            swal("Oops", "Wrong Email Or Password", "error");
            break;
        case 'USER_DISABLED':
            return 'User Disabled';

        default:
            return '';
    }
}

export function saveTokenInLocalStorage(tokenDetails) {
    // tokenDetails.expireDate = new Date(
    //     new Date().getTime() + tokenDetails.expiresIn * 1000,
    // );
    localStorage.setItem('userDetails', JSON.stringify(tokenDetails));
}

export function runLogoutTimer(dispatch, timer, history) {
    setTimeout(() => {
        dispatch(logout(history));
    }, timer);
}
export function checkAutoLogin(dispatch, history) {
    let path = window.location.pathname;
    path = path.split("/");
    path = path[path.length - 1];
    const tokenDetailsString = localStorage.getItem('userDetails');
    const otp=localStorage.getItem('OTP');
    let tokenDetails = '';
    if (tokenDetailsString) {
        tokenDetails = JSON.parse(tokenDetailsString);
            dispatch(loginConfirmedAction(tokenDetails)); 
    }
    else
    {
        dispatch(logout(history));
        return;
    }
    // if(path === "otp-verification")
    // {
    //   console.log('logouted from page')
    //   dispatch(logout(history));
    //   return;
    // }
    // else
    // {
    //     tokenDetails = JSON.parse(tokenDetailsString);
    //     dispatch(loginConfirmedAction(tokenDetails));
    // }
     
    // let expireDate = new Date(tokenDetails.expireDate);
    // let todaysDate = new Date();

    // if (todaysDate > expireDate) {
    //     dispatch(logout(history));
    //     return;
    // }
     

    // const timer = expireDate.getTime() - todaysDate.getTime();
    // runLogoutTimer(dispatch, timer, history);
}
